import PropTypes from 'prop-types';
import styled from 'helpers/styles';
import ComponentStyles from 'styles/mixins/Component.styles';
import DialogContent from '@mui/material/DialogContent';

const StyledDialogContent = styled(DialogContent)` 
  padding: ${props => props.theme.spacing(2)} ${props => props.theme.spacing(3)};

  ${props => props.theme.breakpoints.down('lg')} {
    padding: ${props => props.theme.spacing(2)};
  }
  
  ${ComponentStyles}
`;

StyledDialogContent.propTypes = {
  theme: PropTypes.object
};

export default StyledDialogContent;
